import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	component: PlannerHome,
});

function PlannerHome() {
	const webUrl = import.meta.env.VITE_WEB_URL || "https://localhost:3000";

	return (
		<main className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
			<div className="max-w-xl rounded-3xl border border-border bg-card p-8 text-center shadow-sm">
				<h1 className="font-semibold text-3xl tracking-tight">Planner</h1>
				<p className="mt-3 text-muted-foreground">
					Open a drawing from the main file manager to start planning.
				</p>
				<a
					className="mt-6 inline-flex rounded-full bg-primary px-5 py-2.5 font-medium text-primary-foreground transition hover:bg-primary/90"
					href={`${webUrl}/projects`}
				>
					Open PlanVera
				</a>
			</div>
		</main>
	);
}
